const TEXT_COLUMNS = new Set([
  'product_name',
  'variant_name',
  'product_sku',
  'product_category',
  'customer_name',
  'customer_email',
  'order_number',
  'order_status',
  'boris_action',
  'boris_reason',
  'status',
  'courier_method',
  'courier_company',
]);

export function getTableColumnClass(columnKey: string): string {
  return TEXT_COLUMNS.has(columnKey) ? 'metric-table-cell--text' : 'metric-table-cell--numeric';
}

export function formatTableHeaderLabel(header: string, label: string): string {
  const compactLabels: Record<string, string> = {
    total_sold: 'Uds. vend.',
    totalSold: 'Uds. vend.',
    quantity_sold: 'Uds. vend.',
    total_units_sold: 'Uds. vend.',
    total_cyd: 'Uds. CyD',
    totalCyd: 'Uds. CyD',
    total_cyd_requests: 'Uds. CyD',
    total_products_cyd: 'Uds. CyD',
    cyd_rate: 'Tasa CyD',
    cydRate: 'Tasa CyD',
    product_name: 'Producto',
    customer_email: 'Email',
    customer_name: 'Cliente',
    total_orders: 'Total órdenes',
    total_amount: 'Total ($)',
    totalAmount: 'Total ($)',
    avg_order_value: 'Prom. orden',
    variant_name: 'Variante',
    product_sku: 'SKU',
  };

  return compactLabels[header] ?? label;
}
